export default __webpack_public_path__ + "static/GRID2022 Stock Conflict RGBlight - Simplify-01-sp-4b741878e8eea234faf8f3fda402df2b.svg";